<ng-container *ngIf="earnPointsCard">
  <a [attr.href]="earnPointsCard?.UrlLink || null" [attr.rel]="earnPointsCard?.UrlLink ? 'noopener noreferrer' : null">
    <div class="card-body earn-card-body border-0">
      <ng-container *ngIf="earnPointsCard.Image; else noImage">
        <ng-container *ngTemplateOutlet="withImage"></ng-container>
      </ng-container>
    </div>
  </a>
</ng-container>

<ng-template #noImage>
  <div class="text-center w-100">
    <h5 class="earn-card-points-value">
      {{ earnPointsCard.DisplayText }}
    </h5>
    <div class="earn-card-display line-height-18" [innerHtml]="earnPointsCard.Description | safeHtml"></div>
  </div>
</ng-template>

<ng-template #withImage>
  <img *ngIf="earnPointsCard.Image" alt="" class="earn-card-icon" src="{{ earnPointsCard.Image | contentImage: '7' }}" />

  <div class="flex-column">
    <h5 class="earn-card-points-value mb-2">
      {{ earnPointsCard.DisplayText }}
    </h5>
    <div class="earn-card-display line-height-18" [innerHtml]="earnPointsCard.Description | safeHtml"></div>
  </div>
</ng-template>
